/* ------------------------------------------------------------------
   RAVA - CARD SLIDES

   Cycles each product card's images, moving the size and price tags
   with them, so a grouped product walks through 20 cm / 11 900 Ft,
   24 cm / 13 900 Ft, and so on.

   Every card is driven by one shared clock rather than its own timer,
   so the whole grid changes together on the same beat.

   Where two sizes share a photograph the snippet reaches for the second
   one instead, so something visibly changes on every step rather than
   the card stalling while only the numbers move.

   Cycling pauses while the tab is hidden and while the pointer is over
   a card, so a price never changes under the cursor.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var INTERVAL = 5000;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var cards = [];
  var clock = null;

  function build(root) {
    if (root.dataset.ravaSlidesReady === 'true') return null;
    root.dataset.ravaSlidesReady = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-rava-slide]'));

    // The snippet already reaches for a different photograph when a size
    // reuses the previous one. Slides are never dropped here: even where two
    // sizes genuinely share the only photo there is, the size and the price
    // still have to keep moving.
    if (slides.length < 2) return null;

    var card = root.closest('.card-wrapper') || root.closest('.card') || root.parentNode;

    var entry = {
      slides: slides,
      index: 0,
      hovered: false,
      tagSize: card ? card.querySelector('[data-rava-tag-size]') : null,
      tagPrice: card ? card.querySelector('[data-rava-tag-price]') : null
    };

    if (card) {
      card.addEventListener('mouseenter', function () { entry.hovered = true; });
      card.addEventListener('mouseleave', function () { entry.hovered = false; });
    }

    return entry;
  }

  function advance(entry) {
    if (entry.hovered) return;
    entry.slides[entry.index].classList.remove('is-active');
    entry.index = (entry.index + 1) % entry.slides.length;
    var next = entry.slides[entry.index];
    next.classList.add('is-active');

    var size = next.getAttribute('data-size');
    var price = next.getAttribute('data-price');
    if (entry.tagSize && size) entry.tagSize.textContent = size;
    if (entry.tagPrice && price) entry.tagPrice.innerHTML = price;
  }

  function beat() {
    for (var i = 0; i < cards.length; i++) advance(cards[i]);
  }

  function startClock() {
    if (clock || reduceMotion || document.hidden || !cards.length) return;
    clock = window.setInterval(beat, INTERVAL);
  }

  function stopClock() {
    if (!clock) return;
    window.clearInterval(clock);
    clock = null;
  }

  function scan() {
    var nodes = document.querySelectorAll('[data-rava-slides]');
    for (var i = 0; i < nodes.length; i++) {
      var entry = build(nodes[i]);
      if (entry) cards.push(entry);
    }
    startClock();
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { stopClock(); } else { startClock(); }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Filtering and pagination swap the grid out from under us.
  var main = document.getElementById('MainContent');
  if (main) {
    new MutationObserver(function () { scan(); }).observe(main, { childList: true, subtree: true });
  }
})();
